import { api } from './api';

const login = async (username: string, password: string) => {
  return api.post('auth/login', { username, password });
};

const refreshToken = async (refresh: string) => {
  return api.post('auth/refresh', { refresh });
};
const authApi = { login, refreshToken };

export default authApi;
